import React, { PropsWithChildren } from 'react'
import { ConfigProvider } from 'antd'
import { theme as antdTheme } from 'antd'
import { useGlobalThemeStore } from 'store/globalThemeStore/globalThemeStore'
import { withTheme } from 'styled-components'
import { ThemeModes, ThemeType } from 'theme/theme'

interface AntdConfigProviderProps {
    theme: ThemeType
}

const AntdConfigProvider = ({
    children,
    theme,
}: PropsWithChildren<AntdConfigProviderProps>) => {
    const [{ globalTheme }] = useGlobalThemeStore()

    const { borderRadius, primary, highContrast } = theme

    const lightTheme = {
        token: {
            colorPrimary: primary,
            colorLink: primary,
            colorLinkActive: primary,
            colorLinkHover: primary,
            borderRadius,
        },
    }

    const highContrastTheme = {
        algorithm: antdTheme.darkAlgorithm,

        token: {
            colorPrimary: highContrast.primary,
            colorLink: highContrast.primary,
            colorLinkActive: highContrast.primary,
            colorLinkHover: highContrast.primary,
            borderRadius,
            colorBgBase: highContrast.colorBgBase,
            colorTextBase: highContrast.primary,
            colorText: highContrast.primary,
            colorBgElevated: highContrast.colorBgElevated,
            colorError: highContrast.colorError,
        },
    }

    return (
        <ConfigProvider
            theme={
                globalTheme.mode === ThemeModes.HIGH_CONTRAST
                    ? highContrastTheme
                    : lightTheme
            }
        >
            {children}
        </ConfigProvider>
    )
}

export default withTheme(AntdConfigProvider)
